"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    DynamicResourceBatchRoute: Symbol("DynamicResourceBatchRoute"),
    DynamicResourceBatchClient: Symbol("DynamicResourceBatchClient"),
    DynamicResourceACLClient: Symbol("DynamicResourceACLClient"),
    DynamicResourceACLRoute: Symbol("DynamicResourceACLRoute"),
    DynamicResourceClient: Symbol("DynamicResourceClient"),
    DynamicResourceRoute: Symbol("DynamicResourceRoute"),
    DynamicSchemaClient: Symbol("DynamicSchemaClient"),
    DynamicSchemaRoute: Symbol("DynamicSchemaRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.DynamicResourceACLRoute).to(_1.DynamicResourceACLRoute);
    bind(TYPES.DynamicResourceACLClient).to(_1.DynamicResourceACLClient);
    bind(TYPES.DynamicResourceRoute).to(_1.DynamicResourceRoute);
    bind(TYPES.DynamicResourceClient).to(_1.DynamicResourceClient);
    bind(TYPES.DynamicResourceBatchRoute).to(_1.DynamicResourceBatchRoute);
    bind(TYPES.DynamicResourceBatchClient).to(_1.DynamicResourceBatchClient);
    bind(TYPES.DynamicSchemaRoute).to(_1.DynamicSchemaRoute);
    bind(TYPES.DynamicSchemaClient).to(_1.DynamicSchemaClient);
});
exports.diModule = diModule;
